import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../../shared/GlobalContext/GlobalContext';
import SSOConf from '../../../../modules/constants/SSOConf';

export default function useCleverLoginButton({
  redirectTo,
  redirectErrorTo,
  stateParams,
}) {
  const [state, setState] = useState({});
  const context = useContext(GlobalContext);
  useEffect(() => {
    const loginUrl = SSOConf.clever.getLoginUrl({
      user: context.state.user,
      redirectTo,
      redirectErrorTo,
      stateParams,
    });
    setState({ loginUrl });
  }, [context, redirectTo, stateParams]);
  return { state };
}
